import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TeamModel } from "../../../models/user.model";
import { UserService } from "../../../services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { PaymentService } from "../../../services/payment.service";
import { SubscriptionModel } from "../../../models/team.model";
import { AppTitleService } from "../../../services/title.service";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit, OnDestroy {
  private _userService: UserService = inject(UserService);
  private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private _paymentService: PaymentService = inject(PaymentService);
  private _router: Router = inject(Router);
  private _appTitleService: AppTitleService = inject(AppTitleService);

  TABS: { SIGN_UP: 'SIGN_UP'; SIGN_IN: 'SIGN_IN' } = {
    SIGN_UP: 'SIGN_UP',
    SIGN_IN: 'SIGN_IN',
  };

  activeTab: 'SIGN_UP' | 'SIGN_IN' = this.TABS.SIGN_UP;
  userData!: TeamModel | null;
  loginData!: any;
  isSchool: boolean = false;
  subscriptionData!: SubscriptionModel;

  paymentStatus: 'success' | 'cancelled' | null = null;
  paymentVerified: boolean | null = null;
  private queryParamsSub!: Subscription;
  userSub!: Subscription;

  currentStep!: number;

  constructor() {
    this.userDataSubscription();
  }

  ngOnInit(): void {
    this._userService.changeCurrentUser('team');

    this.paymentStatusSubscribe();

    const user = this._userService.get();
    if (user) this.getUser();

    // Read query param and set active tab
    this._activatedRoute.queryParamMap.subscribe((params) => {
      const tabParam = params.get('tab');
      if (tabParam === 'sign-in') {
        this.setActiveTab(this.TABS.SIGN_IN);
      } else {
        this.setActiveTab(this.TABS.SIGN_UP);
      }
    });
  }

  paymentStatusSubscribe(): void {
    this.queryParamsSub = this._activatedRoute.queryParams.subscribe(params => {
      const paymentStatus = params['payment-status'] || null;
      const paymentId = params['paymentid'];

      if (paymentStatus === 'success' && paymentId) {
        this.paymentStatus = paymentStatus;
        this._paymentService.verifyPayment(paymentId).subscribe((res) => {
          this.paymentVerified = res.verified;
          // Refresh user and subscription so "download app" can show when backend marks it active
          const u = this._userService.get();
          if (u) this.getUser();
          this.clearParams();
        }, error => {
          this.paymentVerified = false;
          this.clearParams();
        });
      }
    });
  }

  clearParams(): void {
    setTimeout(() => {
      this._router.navigate([], {
        relativeTo: this._activatedRoute,
        queryParams: {},
        replaceUrl: true,
      });
    }, 100);
  }

  getUser(): void {
    this._userService.getTeam().subscribe((result) => {
      this.userData = result;
      this.isSchool = this.userData ? this.userData.profile.school : false;
      let loginData: any = this._userService.get();
          loginData.user = result;
      this._userService.set(loginData);
      this.getUserSubscription();
      const profileName = this.userData?.profile?.name;
      if (profileName) {
        this._appTitleService.setTitleFromKey('PAGE_TITLE.FORMAT_HP', { title: `${profileName} profile` });
      } else {
        this._appTitleService.setTitleFromKey('PAGE_TITLE.FORMAT_HP', { title: 'Profile' });
      }
    }, error => {
      if (error.url.includes('/auth/token/refresh/')) {
        this._userService.delete();
      }
    });
  }

  getUserSubscription(): void {
    this._userService.getTeamSubscription().subscribe((result) => {
      this.subscriptionData = result;
    }, error => {
      if (error.url.includes('/auth/token/refresh/')) {
        this._userService.delete();
      }
    });
  }

  setActiveTab(tab: 'SIGN_UP' | 'SIGN_IN'): void {
    this.activeTab = tab;
  }

  userDataSubscription(): void {
    this.userSub = this._userService.user$.subscribe((userData: any | '') => {
      this.loginData = userData;

      if (this.loginData && this.loginData.user) {
        this.userData = this.loginData.user;
      } else {
        this.userData = null;
      }

      this.isSchool = this.userData ? this.userData.profile.school : false;
    });
  }

  setCurrentStep(step: number): void {
    this.currentStep = step;
  }

  ngOnDestroy() {
    if (this.queryParamsSub) this.queryParamsSub.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
  }
}
